import useSWR, { mutate } from 'swr';

import { suggestionService } from '../services/suggestionService';

const KEY = 'admin/suggestions/pending-count';

/**
 * Contador de sugestões pendentes usado no menu de admin.
 * Só busca quando `enabled` (usuário é admin da plataforma).
 *
 * É só um badge: se a API falhar, o menu segue funcionando com 0 (badge
 * oculto) e não fica refazendo a chamada em loop — a próxima tentativa
 * acontece ao recarregar a página ou depois de mudar o status de uma sugestão.
 */
export default function useSuggestionsPendingCount(enabled) {
  const { data, error } = useSWR(enabled ? KEY : null, () => suggestionService.pendingCount(), {
    revalidateOnFocus: false,
    shouldRetryOnError: false
  });

  if (error || typeof data !== 'number') return 0;
  return data;
}

/** Revalida o contador depois que o admin muda o status de uma sugestão. */
export function refreshSuggestionsPendingCount() {
  return mutate(KEY);
}
